var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap justify-center"},[_c('div',{staticClass:"max-w-xl min-w-full sm:min-w-30 m-2"},[_c('div',{staticClass:"bg-white rounded-lg shadow-card p-8 sm:p-12"},[_c('Spinner',{staticClass:"mx-auto"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }